import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawayType = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/briefs/giveaways/types' });

  return data;
};

export default getGiveawayType;
